/**
 * Takes strings or objects to return a combined query string
 */
import qsParse from '@sls-react/utils/qsParse';
import qsStringify from '@sls-react/utils/qsStringify';
import { IStringifyOptions } from 'qs';


export default function qsUpdateString(
  input: (string | undefined | Record<string, any>)[],
  options?: IStringifyOptions,
) {
  const combined = input.reduce<Record<string, any>>((prev, cur) => {
    if (typeof cur === 'string') {
      return {
        ...prev,
        ...qsParse(cur),
      };
    } else {
      return {
        ...prev,
        ...cur,
      };
    }
  }, {});

  return qsStringify(combined, options);
}
